import { Notifications } from "@mui/icons-material";
import HelpIcon from "@mui/icons-material/Help";
import InfoRoundedIcon from "@mui/icons-material/InfoRounded";
import MenuIcon from "@mui/icons-material/Menu";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import OndemandVideoIcon from "@mui/icons-material/OndemandVideo";
import {
  AppBar,
  Badge,
  Box,
  Drawer,
  Grid,
  IconButton,
  Menu,
  MenuItem,
  Toolbar,
  Tooltip,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import useMediaQuery from "@mui/material/useMediaQuery";
import moment from "moment";
import PropTypes from "prop-types";
import React, { useLayoutEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import logo from "../assets/svg/logo.svg";
import { logoutapp } from "../services/Validation";
import SideMenu from "./SideMenu";
import { VisualizadorAyudas } from "../componentes/Ayuda/VisualizadorAyudas";
import { getAyuda } from "../componentes/Ayuda/ServicesAyuda";
import { NotificationList } from "./NotificationList";
import axios from "axios";


export const IconsMenu = (icon: string) => {
  switch (icon) {
    case "OndemandVideoIcon":
      return <OndemandVideoIcon />;
    case "MenuBookIcon":
      return <MenuBookIcon />;
    case "HelpIcon":
      return <HelpIcon />;
  }
};

// ancho del drawer
const drawerWidth = 300;
const ColorGris = grey[600];

// const endpoint = 'http://127.0.0.1:8000/api/'
function NavBar(props: { children?: any; window?: any }) {
  const navigate = useNavigate();
  // const { window } = props;
  const [mobileOpen, setMobileOpen] = useState(false);
  const [showNotifications, setShowNotifications] = useState(false);

  const auth = true;

  // esto es de la parte de submenus de los iconos de mensaje y notificaciones
  const [anchorAlerta, setAnchorAlerta] = useState<null | HTMLElement>(null);
  const handleMenuAlerta = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorAlerta(event.currentTarget);
    setShowNotifications(showNotifications ? false : true);

  };
  const handleCloseAlerta = () => {
    setAnchorAlerta(null);

  };

  const [anchorNotificaciones, setAnchorNotificaciones] =
    useState<null | HTMLElement>(null);
  const handleMenuNotificaciones = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorNotificaciones(event.currentTarget);
  };
  const handleCloseNotificaciones = () => {
    setAnchorNotificaciones(null);
  };

  const handleLogout = async (e: { preventDefault: () => void }) => {
    e.preventDefault();
    logoutapp();
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [Cantidad, setCantidad] = useState(0);
  const [isDrawerNotificationOpen, setIsDrawerNotificationOpen] =
    useState(false);
  const query = {
    isXs: useMediaQuery("(min-width: 0px) and (max-width: 1025px)"),
  };

  interface MenuObject {
    Id: string;
    FechaDeCreacion: string;
    UltimaModificacion: string;
    CreadoPor: string;
    ModificadoPor: string;
    Deleted: number;
    Menu: string;
    Descripcion: string;
    MenuPadre: string;
    Icon: string | null;
    Path: string;
    Nivel: number;
    Orden: number;
    ControlInterno: string | null;
    IdApp: string;
    item: MenuObject[]; // Esto es para el arreglo de objetos anidados, si los hay
  }

  let idMenu = localStorage.getItem("IdMenuActual") || "";

  const [arrayAyudas, setArrayAyudas] = useState<any[]>([]);

  const [openVAyudas, setOpenVAyudas] = useState(false);
  const [option, setOption] = useState("Videos");

  function handleCloseVAyudas() {
    setOpenVAyudas(false);

  }
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const handleMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  useLayoutEffect(() => {
    NumeroNotificaciones();
  }, []);

  const NumeroNotificaciones = async () => {
    //const endpoint = ENDPOINTS.NoticacionLeida;
    //const ambiente = AMBIENTES.PABMI;

    //const response = createAPIEndpoint(endpoint,ambiente).patchById(id);
    const response = await axios({
      method: "GET",
      url: process.env.REACT_APP_APPLICATION_ENDPOINT + "/numero-notificaciones",
      headers: {
        "Content-Type": "application/json",
        Authorization: localStorage.getItem("jwtToken") || "",
      },
    })
      .then(function (response) {
        //return response.data; // Regresa los datos de la respuesta
        setCantidad(response.data.unreadCount);
      })
      .catch(function (error) {
        return false;
      });

  };

  if (auth)
    return (
      <>
        {" "}
        <Box>
          <AppBar position="static">
            <Toolbar variant="dense">
              <Grid
                container
                sx={{ alignItems: "center", justifyContent: "space-between" }}
              >
                <Grid item mt={0.5}>
                  <IconButton
                    size="large"
                    color="inherit"
                    onClick={() => setIsDrawerOpen(true)}
                  >
                    <Tooltip title="Menú Principal">
                      <MenuIcon />
                    </Tooltip>
                  </IconButton>
                </Grid>
                <Grid item mt={0.5}>
                  <img src={logo} style={{ height: "40px" }} alt={"logo"}></img>
                </Grid>
                <Menu
                  id="menu-appbar"
                  anchorEl={anchorEl}
                  anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  keepMounted
                  transformOrigin={{
                    vertical: 'top',
                    horizontal: 'right',
                  }}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                >
                  {<MenuItem onClick={() => { getAyuda(setArrayAyudas, "1", "Videos"); setOpenVAyudas(true); setOption("Videos") }}>{IconsMenu("OndemandVideoIcon")} VER TUTORIALES </MenuItem>}
                  {<MenuItem onClick={() => { getAyuda(setArrayAyudas, "1", "Guías"); setOpenVAyudas(true); setOption("Guías") }}>{IconsMenu("MenuBookIcon")} VER GUÍAS </MenuItem>}
                  {<MenuItem onClick={() => { getAyuda(setArrayAyudas, "1", "Preguntas"); setOpenVAyudas(true); setOption("Preguntas") }}>{IconsMenu("HelpIcon")} PREGUNTAS </MenuItem>}

                </Menu>


                {openVAyudas ? <VisualizadorAyudas handleClose={() => { handleCloseVAyudas() }} arrayAyudas={arrayAyudas} value={option} /> : null}

                <Grid
                  mt={1.5}
                  display={"flex"}
                  justifyContent={"space-between"}
                  width={85}
                >
                  {/* <NavMessages /> */}
                  <Grid>
                    <Badge badgeContent={Cantidad} color="secondary"
                      sx={{
                        "& .MuiBadge-badge": {
                          top: 10, // Ajusta estos valores para mover la burbuja
                          right: 10, // Ajusta estos valores para mover la burbuja
                          height: 18,
                          minWidth: 18,
                          fontSize: 12,
                          padding: "0 4px",
                        },
                      }}
                    >

                      <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        color="inherit"
                        onClick={handleMenu}
                      >
                        <InfoRoundedIcon />
                      </IconButton>
                      <IconButton
                        size="large"
                        aria-label="account of current user"
                        aria-controls="menu-appbar"
                        aria-haspopup="true"
                        onClick={handleMenuAlerta}
                        color="inherit"
                      >
                        <Notifications />

                      </IconButton>
                      {/* {userName} */}
                      {/* <Menu
                id="appbar-alerta"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                keepMounted
                transformOrigin={{
                  vertical: "top",
                  horizontal: "right",
                }}
                open={Boolean(anchorAlerta)}
                onClose={handleCloseAlerta}
              >
                <MenuItem onClick={handleCloseAlerta}>Profile</MenuItem>
                <MenuItem onClick={handleLogout}>Logout</MenuItem>
              </Menu> */}
                    </Badge>
                  </Grid>
                  <Grid></Grid>
                </Grid>
              </Grid>
              <Drawer
                anchor="left"
                open={isDrawerOpen}
                onClose={() => setIsDrawerOpen(false)}
              >
                <Grid item container direction="column" mt={2}>
                  <SideMenu setIsDrawerOpen={setIsDrawerOpen} />
                </Grid>
              </Drawer>
            </Toolbar>
          </AppBar>
          <Grid
            container
            sx={{ width: "100%", height: "inherit", paddingX: 2, paddingY: 4 }}
          >
            {props.children}
          </Grid>
        </Box>
        {/* Notifications Component */}
        {showNotifications && (
          <Grid style={{ marginRight: "auto" }}>
            {<NotificationList handleNotificaciones={NumeroNotificaciones} />}
          </Grid>
        )}
      </>
    );
  else return <Grid>{props.children}</Grid>;
}

NavBar.propTypes = {
  window: PropTypes.func,
};

export default NavBar;
